import { render, staticRenderFns } from "./export-results.vue?vue&type=template&id=31a9926a&"
import script from "./export-results.vue?vue&type=script&lang=ts&"
export * from "./export-results.vue?vue&type=script&lang=ts&"
import style0 from "./export-results.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports